import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCollectionReviews {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        perMove: 1,
        type: 'loop',
        gap: '16px',
        autoplay: true,
        arrows: false,
        pagination: false,
        mediaQuery: 'min',
        padding: '16px',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            perPage: 2,
          },
          [unitlessBreakpoints.lg]: {
            perPage: 3,
          },
          [unitlessBreakpoints.xl]: {
            perPage: 4,
          },
        },
      },
      true,
    );
  }
}
